import { AppUI } from '@seedlang/state';

const MemrevOnly = ({ children }) => {
  if (AppUI.siteIsSeedlang) {
    return null;
  }

  return children;
};

export default MemrevOnly;